import React, { useEffect} from 'react';
import scanqr from '../img/qrschool.jpg'; 
import backdetails from '../img/bankdetails.jpg';

export default function Payment(props) {
  const { dispMsg, setDispMsg } = props;
  const [applicantId, setApplicantId] = React.useState('');



  // Function to retrieve tapplicantID cookie value
  function getApplicantIdFromCookie() {
    if (typeof document !== 'undefined') {
      const match = document.cookie.match(/(?:^|; )tapplicantID=([^;]*)/);
      return match ? decodeURIComponent(match[1]) : '';
    }
    return '';
  }

  useEffect(() => {
    const id = getApplicantIdFromCookie();
    setApplicantId(id);
    //setDispMsg("payment");
  }, []);

    return (
      <div className='container'>
        <h2> Payment Details </h2>
                {dispMsg? <div className='alert alert-info'>{dispMsg}</div>:null}

        {applicantId && (
          <div className='alert alert-info'>Reference Application ID: {applicantId}</div>
        )}
        <img src={backdetails} alt="bank-details" className='img-fluid' style={{width: "100%", margin: "20px auto", display: "block"}} />
        <img src={scanqr} alt="QR Code" className='img-fluid' style={{width: "50%", margin: "20px auto", display: "block"}} />
      </div>
    );
}
